'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'person-digging';
var width = 576;
var height = 512;
var aliases = ["digging"];
var unicode = 'f85e';
var svgPathData = 'M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM1.8 200.6c4.1-7.8 13.8-10.9 21.6-6.8l39.9 20.8 14.1-25.4c15.5-27.9 45-45.3 76.9-45.3l23.6 0c39.1 0 73.5 25.8 84.5 63.4l38.3 131.1 82.2 42.9 37.7-62.8c12.4-20.7 42.5-20.7 54.9 0l86.9 144.9c12.8 21.3-2.6 48.5-27.4 48.5l-173.9 0c-24.9 0-40.2-27.1-27.4-48.5L366.4 408.9 8.6 222.2c-7.8-4.1-10.9-13.8-6.8-21.6zM261.4 318L231.8 216.3c-7-23.9-28.9-40.3-53.8-40.3l-23.6 0c-20.3 0-39.1 11-49 28.8L91.7 229.5 261.4 318zM70.5 321.4l144 64c5.8 2.6 9.5 8.3 9.5 14.6l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-85.6-117.9-52.4-42.8 142.6c-2.5 8.5-11.5 13.3-19.9 10.7S-1.9 499.9 .7 491.4l48-160c1.3-4.4 4.5-8 8.6-9.9s9-1.9 13.2-.1zM448 335.1L361.1 480 534.9 480 448 335.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonDigging = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;